import { useContext, useState } from "react";
import { Modal, Tooltip } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { FaClipboardList, FaAppleAlt } from "react-icons/fa";
import { APP_ROUTES } from "../../PageRouting/approutes";
import { MdJoinLeft, MdOutlineSwitchAccount } from "react-icons/md";
import dashboard from "../../Assets/Icons/dashboard.svg";
import calender from "../../Assets/Icons/calendar.svg";
import slot from "../../Assets/Icons/slot.svg";
import user from "../../Assets/Icons/patient.svg";
import payment from "../../Assets/Icons/payment.svg";
import billing from "../../Assets/Icons/billing.svg";
import order from "../../Assets/Icons/order.svg";
import referal from "../../Assets/Icons/referal.svg";
import settings from "../../Assets/Icons/settings.svg";
import logout from "../../Assets/Icons/logout.svg";
import { VoiceCommandContext } from "../Pages/VoiceCommand/VoiceContext";
import { BiClinic } from "react-icons/bi";
import { CiViewList } from "react-icons/ci";
import { BarChart3 } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import {
  SHOWALERTTRUE,
  SHOWALERTFALSE,
  SET_ROUTE,
} from "../../Redux/actions/CommonActions";
import { db } from "../../config/firebase";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import {
  clearLoggedUser,
  clearSelectedAppt,
} from "../../Redux/actions/UserActions";
import { deleteCallRecord } from "../../config/firebase";

function Sidemenu({ isMenuOpen }) {
  const { isListening, setIsListening } = useContext(VoiceCommandContext);
  const { alert, route } = useSelector((state) => state.common);
  const location = useLocation();
  const history = useHistory();
  const [pageRoute, setPageRoute] = useState("");
  const [LogoutWarning, setLogOutWarning] = useState(false);
  const [isRpmSubMenuOpen, setIsRpmSubMenuOpen] = useState(false);
  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;
  const dispatch = useDispatch();
  const { selectedAppt, loggedUser } = useSelector((state) => state.user);

  const handleCancel = () => {
    dispatch({ type: SHOWALERTFALSE });
    dispatch({ type: SET_ROUTE, payload: "" });
  };

  const isMenuItemActive = (path) => {
    return location.pathname === path;
  };

  const handleNavigation = (path) => {
    if (location.pathname === APP_ROUTES.VIDEOCALL) {
      setPageRoute(path);
      setIsListening(false);
      dispatch({ type: SHOWALERTTRUE });
      dispatch({ type: SET_ROUTE, payload: path });
    } else if (path === APP_ROUTES.LOGINFORM) {
      sessionStorage.clear();
      setPageRoute("");
      history.push(path);
    } else {
      setPageRoute("");
      history.push(path);
    }
  };

  const handleLogout = (path) => {
    if (location.pathname === APP_ROUTES.VIDEOCALL) {
      setPageRoute(path);
      dispatch({ type: SHOWALERTTRUE });
      dispatch({ type: SET_ROUTE, payload: path });
    } else {
      setLogOutWarning(true);
      setPageRoute(path);
      dispatch({ type: SET_ROUTE, payload: path });
    }
  };

  const handleLogOutOk = () => {
    sessionStorage.clear();
    dispatch({ type: SHOWALERTFALSE });
    dispatch(clearLoggedUser(null));
    dispatch(clearSelectedAppt(null));
    history.push(route);
  };

  const handleLogOutCancel = () => {
    setLogOutWarning(false);
    dispatch({ type: SET_ROUTE, payload: "" });
  };

  // const onLeave = async () => {
  //   dispatch({ type: SHOWALERTFALSE });
  //   await deleteFirebaseCall(selectedAppt.appointmentId);
  //   sessionStorage.removeItem("selectedAppt");
  //   dispatch(clearSelectedAppt(null));
  //   sessionStorage.removeItem("callRoomId");
  //   if (route == APP_ROUTES.LOGINFORM) {
  //     dispatch(clearLoggedUser(null));
  //     dispatch(clearSelectedAppt(null));
  //     sessionStorage.clear();
  //   }
  //   history.push(route);
  // };

  const onLeave = async () => {
    dispatch({ type: SHOWALERTFALSE });

    const appointmentId = selectedAppt?.appointmentId;
    const doctorUserId = loggedUser?.user?.userId;

    // Safe delete — only removes if this doctor was the original caller
    await deleteCallRecord(appointmentId, doctorUserId);

    sessionStorage.removeItem("selectedAppt");
    sessionStorage.removeItem("callRoomId");
    dispatch(clearSelectedAppt(null));

    if (route === APP_ROUTES.LOGINFORM) {
      dispatch(clearLoggedUser(null));
      sessionStorage.clear();
    }
    history.push(route);
  };

  const deleteFirebaseCall = async (roomId) => {
    try {
      // const doctorId = loginResultObject?.user?.userId;
      // if (!doctorId) return;

      // const callsRef = collection(db, "calls");

      // const q = query(
      //   callsRef,
      //   where("incomingCall.callerId", "==", doctorId)
      // );

      // const snapshot = await getDocs(q);

      // snapshot.forEach(async (docSnap) => {
      //   await deleteDoc(doc(db, "calls", docSnap.id));
      // });
      const callRef = doc(db, "calls", roomId);
      const snap = await getDoc(callRef);

      // Doc already gone → nothing to do
      if (!snap.exists()) return;

      const callData = snap.data();
      const callerId = callData?.incomingCall?.callerId;

      if (callerId !== loggedUser?.user?.userId) {
        console.warn("Non-caller attempted to delete call. Ignored.");
        return;
      }

      await deleteDoc(callRef);
    } catch (err) {
      console.error("Error deleting Firebase call:", err);
    }
  };

  return (
    <ul className={`flex gap-3 flex-col overflow-y-scroll scrollWidth p-2`}>
      <Modal
        title="Alert"
        open={alert}
        onCancel={handleCancel}
        width={"30%"}
        footer={
          <div className="flex items-end gap-1 justify-end">
            <button
              className="mx-1 p-1 w-44 h-8 text-[#189FAA] font-semibold  rounded-md  bg-white border-2 border-[#979797] mt-2"
              onClick={onLeave}
            >
              Leave without saving
            </button>
            <button
              className="mx-1 p-1 w-32 h-8 font-semibold text-white bg-brand-primaryColor rounded-md"
              onClick={handleCancel}
            >
              Stay on page
            </button>
          </div>
        }
      >
        You haven't saved your changes. Are you sure you want to proceed?
      </Modal>

      <Modal
        title="Logout"
        open={LogoutWarning}
        onOk={handleLogOutOk}
        onCancel={handleLogOutCancel}
        width={"20%"}
        footer={
          <div className="flex">
            <button
              className="mx-1 p-1 w-36 font-semibold bg-white border-[#189FAA] border  rounded-md"
              onClick={handleLogOutCancel}
            >
              Cancel
            </button>
            <button
              className="mx-1 p-1 w-36 font-semibold  border border-[#189FAA] text-white rounded-md"
              onClick={handleLogOutOk}
            >
              Yes
            </button>
          </div>
        }
      >
        Are you sure to log out?
      </Modal>
      <li>
        <div
          onClick={() => handleNavigation(APP_ROUTES.DASHBOARD)}
          className={`flex items-center gap-3 md:px-2 py-2  cursor-pointer  ${
            isMenuItemActive(APP_ROUTES.DASHBOARD)
              ? "bg-brand-primaryColor  rounded-lg"
              : " "
          } `}
        >
          <div>
            <Tooltip placement="right" title={"Dashboard"}>
              <img
                src={dashboard}
                alt=""
                className={` h-6 w-6 ${
                  isMenuItemActive(APP_ROUTES.DASHBOARD)
                    ? "text-white bg-white p-[3px] rounded-lg"
                    : " text-[#189FAA] "
                }`}
              />
            </Tooltip>
          </div>
          <span
            className={`${
              isMenuItemActive(APP_ROUTES.DASHBOARD)
                ? "text-white font-bold"
                : "text-[#041346] "
            }  font-semibold md:text-base text-sm ${
              !isMenuOpen ? "hidden" : ""
            }`}
          >
            Dashboard
          </span>
        </div>
      </li>
      <li>
        <div
          onClick={() => handleNavigation(APP_ROUTES.APPOINTMENTS)}
          className={`flex items-center gap-3 md:px-2 py-2  cursor-pointer  ${
            isMenuItemActive(APP_ROUTES.APPOINTMENTS)
              ? "bg-brand-primaryColor  rounded-lg"
              : " "
          } `}
        >
          <div>
            <Tooltip placement="right" title={"Appointments"}>
              <img
                src={calender}
                alt=""
                className={` h-6 w-6 ${
                  isMenuItemActive(APP_ROUTES.APPOINTMENTS)
                    ? "text-white bg-white p-[3px] rounded-lg"
                    : " text-[#189FAA] "
                }`}
              />
            </Tooltip>
          </div>
          <span
            className={`${
              isMenuItemActive(APP_ROUTES.APPOINTMENTS)
                ? "text-white font-bold"
                : "text-[#041346]"
            } font-semibold md:text-base text-sm ${
              !isMenuOpen ? "hidden" : ""
            }`}
          >
            Appointments
          </span>
        </div>
      </li>
      {loginResultObject?.user?.himsApplicable === "Y" && (
        <li>
          <div
            onClick={() => handleNavigation(APP_ROUTES.ANALYTICS)}
            className={`flex items-center gap-3 md:px-2 py-2 cursor-pointer ${
              isMenuItemActive(APP_ROUTES.ANALYTICS)
                ? "bg-brand-primaryColor rounded-lg"
                : ""
            }`}
          >
            <div>
              <Tooltip placement="right" title={"Analytics"}>
                <div
                  className={`h-6 w-6 flex items-center justify-center rounded-lg ${
                    isMenuItemActive(APP_ROUTES.ANALYTICS)
                      ? "text-[#189FAA] bg-white p-[3px]"
                      : "text-[#189FAA]"
                  }`}
                >
                  <BarChart3 className="h-5 w-5" />
                </div>
              </Tooltip>
            </div>
            <span
              className={`${
                isMenuItemActive(APP_ROUTES.ANALYTICS)
                  ? "text-white font-bold"
                  : "text-[#041346]"
              } font-semibold md:text-base text-sm ${
                !isMenuOpen ? "hidden" : ""
              }`}
            >
              Analytics
            </span>
          </div>
        </li>
      )}
      <li>
        <div
          onClick={() => handleNavigation(APP_ROUTES.SLOT)}
          className={`flex items-center gap-3 md:px-2 py-2  cursor-pointer  ${
            isMenuItemActive(APP_ROUTES.SLOT)
              ? "bg-brand-primaryColor  rounded-lg"
              : " "
          } `}
        >
          <div>
            <Tooltip placement="right" title={"Slot"}>
              <img
                src={slot}
                alt=""
                className={` h-6 w-6 ${
                  isMenuItemActive(APP_ROUTES.SLOT)
                    ? "text-white bg-white p-[3px] rounded-lg"
                    : " text-[#189FAA] "
                }`}
              />
            </Tooltip>
          </div>
          <span
            className={`${
              isMenuItemActive(APP_ROUTES.SLOT)
                ? "text-white font-bold"
                : "text-[#041346]"
            } font-semibold md:text-base text-sm ${
              !isMenuOpen ? "hidden" : ""
            }`}
          >
            Slot
          </span>
        </div>
      </li>
      <li>
        <div
          onClick={() => handleNavigation(APP_ROUTES.PATIENTS)}
          className={`flex items-center gap-3 md:px-2 py-2  cursor-pointer  ${
            isMenuItemActive(APP_ROUTES.PATIENTS)
              ? "bg-brand-primaryColor  rounded-lg"
              : " "
          } `}
        >
          <div>
            <Tooltip placement="right" title={"Patients"}>
              <img
                src={user}
                alt=""
                className={` h-6 w-6 ${
                  isMenuItemActive(APP_ROUTES.PATIENTS)
                    ? "text-white bg-white p-[3px] rounded-lg"
                    : "text-[#189FAA]  "
                }`}
              />
            </Tooltip>
          </div>
          <span
            className={`${
              isMenuItemActive(APP_ROUTES.PATIENTS)
                ? "text-white font-bold"
                : "text-[#041346]"
            } font-semibold md:text-base text-sm ${
              !isMenuOpen ? "hidden" : ""
            }`}
          >
            Patients
          </span>
        </div>
      </li>

      {loginResultObject.user.rpmApplicable === "Y" && (
        <li
          className="w-full cursor-pointer flex items-center flex-col"
          onClick={(e) => {
            e.stopPropagation();
            setIsRpmSubMenuOpen(!isRpmSubMenuOpen);
          }}
        >
          <div className="w-full flex items-center my-1">
            <Tooltip placement="right" color="Navy" title={"RPM"}>
              <MdOutlineSwitchAccount
                className={`h-5 w-5 ${isMenuOpen ? "mr-3 ml-2" : "ml-2"} ${
                  location.pathname === "/vitalparams" ||
                  location.pathname === "/taskfrequency" ||
                  location.pathname === "/devicesetup" ||
                  location.pathname === "/rpmbillingreport"
                    ? " text-black"
                    : "text-black"
                }`}
              />
            </Tooltip>
            <div>
              <span
                className={`text-bgBlue  font-medium  md:text-base text-sm ${
                  !isMenuOpen ? "hidden" : ""
                }`}
              >
                RPM
              </span>
            </div>
          </div>
          {isRpmSubMenuOpen && (
            <ul className="pl-2.5">
              <li className="flex gap-3 items-center px-1 py-2">
                {/* <PiDiamondBold className="text-black   md:text-[10px] text-[5px]" /> */}
                <div
                  onClick={() => handleNavigation(APP_ROUTES.RPMDASHBOARD)}
                  className="md:font-normal font-extralight md:text-sm text-xs text-bgBlue flex items-center gap-2 cursor-pointer"
                >
                  <Tooltip
                    placement="right"
                    color="Navy"
                    title={"RPM Dashboard"}
                  >
                    <CiViewList
                      className={`h-5 w-5 ${
                        isMenuItemActive(APP_ROUTES.RPMDASHBOARD)
                          ? " text-black"
                          : "text-black rounded-lg"
                      }`}
                    />
                  </Tooltip>
                  <span
                    className={`font-medium md:text-base text-sm text-[#041346] ${
                      !isMenuOpen ? "hidden" : ""
                    } ${
                      isMenuItemActive(APP_ROUTES.RPMDASHBOARD)
                        ? "text- font-semibold text-sm"
                        : "text-black"
                    }`}
                  >
                    RPM Dashboard
                  </span>
                </div>
              </li>
              <li className="flex gap-3 items-center px-1 py-2">
                {/* <PiDiamondBold className="text-black   md:text-[10px] text-[5px]" /> */}
                <div
                  onClick={() => handleNavigation(APP_ROUTES.RPMVITALPARAMS)}
                  className="md:font-normal font-extralight md:text-sm text-xs text-bgBlue flex items-center gap-2 cursor-pointer"
                >
                  <Tooltip
                    placement="right"
                    color="Navy"
                    title={"Vital Parameters"}
                  >
                    <CiViewList
                      className={`h-5 w-5 ${
                        isMenuItemActive(APP_ROUTES.RPMVITALPARAMS)
                          ? " text-black"
                          : "text-black rounded-lg"
                      }`}
                    />
                  </Tooltip>
                  <span
                    className={`font-medium md:text-base text-sm text-[#041346] ${
                      !isMenuOpen ? "hidden" : ""
                    } ${
                      isMenuItemActive(APP_ROUTES.RPMVITALPARAMS)
                        ? "text- font-semibold text-sm"
                        : "text-black"
                    }`}
                  >
                    Vital Parameters
                  </span>
                </div>
              </li>
              <li className="flex gap-3 items-center px-1 py-2">
                {/* <PiDiamondBold className="text-black   md:text-[10px] text-[5px]" /> */}
                <div
                  onClick={() => handleNavigation(APP_ROUTES.RPMTASKFREQUENCY)}
                  className="md:font-normal font-extralight md:text-sm text-xs text-bgBlue flex items-center gap-2"
                >
                  <Tooltip placement="right" color="Navy" title={"Task"}>
                    <FaClipboardList
                      className={`h-5 w-5 ${
                        isMenuItemActive(APP_ROUTES.RPMTASKFREQUENCY)
                          ? " text-black rounded-lg"
                          : "text-black"
                      }`}
                    />
                  </Tooltip>
                  <span
                    className={`font-medium md:text-base text-sm text-[#041346] ${
                      !isMenuOpen ? "hidden" : ""
                    } ${
                      isMenuItemActive(APP_ROUTES.RPMTASKFREQUENCY)
                        ? "font-semibold text-sm"
                        : ""
                    }`}
                  >
                    Task/Frequency
                  </span>
                </div>
              </li>
              <li className="flex gap-3 items-center px-1 py-2">
                <div
                  onClick={() => handleNavigation(APP_ROUTES.DEVICESETUP)}
                  className="md:font-normal font-extralight md:text-sm text-xs text-bgBlue flex items-center gap-2"
                >
                  <Tooltip
                    placement="right"
                    color="Navy"
                    title={"Device setup"}
                  >
                    <MdJoinLeft
                      className={`h-5 w-5 ${
                        isMenuItemActive(APP_ROUTES.DEVICESETUP)
                          ? " text-black rounded-lg"
                          : "text-black"
                      }`}
                    />
                  </Tooltip>

                  <span
                    className={`font-medium md:text-base text-sm text-[#041346] ${
                      !isMenuOpen ? "hidden" : ""
                    } ${
                      isMenuItemActive(APP_ROUTES.DEVICESETUP)
                        ? "text-black font-semibold text-sm"
                        : ""
                    }`}
                  >
                    Device setup
                  </span>
                </div>
              </li>
              <li className="flex gap-3 items-center px-1 py-2">
                <div
                  onClick={() => handleNavigation(APP_ROUTES.RPMACTIVITYREPORT)}
                  className="md:font-normal font-extralight md:text-sm text-xs text-bgBlue flex items-center gap-2"
                >
                  <Tooltip
                    placement="right"
                    color="Navy"
                    title={"User Mapped Clinics"}
                  >
                    <MdJoinLeft
                      className={`h-5 w-5 ${
                        isMenuItemActive(APP_ROUTES.RPMACTIVITYREPORT)
                          ? " text-black rounded-lg"
                          : "text-black"
                      }`}
                    />
                  </Tooltip>

                  <span
                    className={`font-medium md:text-base text-sm text-[#041346] ${
                      !isMenuOpen ? "hidden" : ""
                    } ${
                      isMenuItemActive(APP_ROUTES.RPMACTIVITYREPORT)
                        ? "text-black font-semibold text-sm"
                        : ""
                    }`}
                  >
                    Activity Report
                  </span>
                </div>
              </li>
            </ul>
          )}
        </li>
      )}

      {/* inpatient-new */}
      {loginResultObject.user.himsApplicable === "Y" && (
        <li>
          <div
            onClick={() => handleNavigation(APP_ROUTES.INPATIENTS)}
            className={`flex items-center gap-3 md:px-2 py-2  cursor-pointer  ${
              isMenuItemActive(APP_ROUTES.INPATIENTS)
                ? "bg-brand-primaryColor  rounded-lg"
                : " "
            } `}
          >
            <div>
              <Tooltip placement="right" title={"In-Patients"}>
                <img
                  src={user}
                  alt=""
                  className={` h-6 w-6 ${
                    isMenuItemActive(APP_ROUTES.INPATIENTS)
                      ? "text-white bg-white p-[3px] rounded-lg"
                      : "text-[#189FAA]  "
                  }`}
                />
              </Tooltip>
            </div>
            <span
              className={`${
                isMenuItemActive(APP_ROUTES.INPATIENTS)
                  ? "text-white font-bold"
                  : "text-[#041346]"
              } font-semibold md:text-base text-sm ${
                !isMenuOpen ? "hidden" : ""
              }`}
            >
              In-Patients
            </span>
          </div>
        </li>
      )}

      <li>
        <div
          onClick={() => handleNavigation(APP_ROUTES.PAYMENTS)}
          className={`flex items-center gap-3 md:px-2 py-2  cursor-pointer  ${
            isMenuItemActive(APP_ROUTES.PAYMENTS)
              ? "bg-brand-primaryColor  rounded-lg"
              : " "
          } `}
        >
          <div>
            <Tooltip placement="right" title={"Payments"}>
              <img
                src={payment}
                alt=""
                className={` h-6 w-6 ${
                  isMenuItemActive(APP_ROUTES.PAYMENTS)
                    ? "text-white bg-white p-[3px] rounded-lg"
                    : "text-[#189FAA]  "
                }`}
              />
            </Tooltip>
          </div>
          <span
            className={`${
              isMenuItemActive(APP_ROUTES.PAYMENTS)
                ? "text-white font-bold"
                : "text-[#041346]"
            } font-semibold md:text-base text-sm ${
              !isMenuOpen ? "hidden" : ""
            }`}
          >
            Payments
          </span>
        </div>
      </li>

      <li>
        <div
          onClick={() => handleNavigation(APP_ROUTES.BILLINGREPORTS)}
          className={`flex items-center gap-3 md:px-2 py-2  cursor-pointer  ${
            isMenuItemActive(APP_ROUTES.BILLINGREPORTS)
              ? "bg-brand-primaryColor rounded-lg"
              : " "
          } `}
        >
          <div>
            <Tooltip placement="right" title={"Billing Reports"}>
              <img
                src={billing}
                alt=""
                className={` h-6 w-6 ${
                  isMenuItemActive(APP_ROUTES.BILLINGREPORTS)
                    ? "text-white bg-white p-[3px] rounded-lg"
                    : "text-[#189FAA]  "
                }`}
              />
            </Tooltip>
          </div>
          <span
            className={`${
              isMenuItemActive(APP_ROUTES.BILLINGREPORTS)
                ? "text-white font-bold"
                : "text-[#041346]"
            } font-semibold md:text-base text-sm ${
              !isMenuOpen ? "hidden" : ""
            }`}
          >
            Billing Reports
          </span>
        </div>
      </li>
      <li>
        <div
          onClick={() => handleNavigation(APP_ROUTES.ORDERREPORT)}
          className={`flex items-center gap-3 md:px-2 py-2  cursor-pointer  ${
            isMenuItemActive(APP_ROUTES.ORDERREPORT)
              ? "bg-brand-primaryColor rounded-lg"
              : " "
          } `}
        >
          <div>
            <Tooltip placement="right" title={"Order Reports"}>
              <img
                src={order}
                alt=""
                className={` h-6 w-6 ${
                  isMenuItemActive(APP_ROUTES.ORDERREPORT)
                    ? "text-white bg-white p-[3px] rounded-lg"
                    : "text-[#189FAA]  "
                }`}
              />
            </Tooltip>
          </div>
          <span
            className={`${
              isMenuItemActive(APP_ROUTES.ORDERREPORT)
                ? "text-white font-bold"
                : "text-[#041346]"
            } font-semibold md:text-base text-sm ${
              !isMenuOpen ? "hidden" : ""
            }`}
          >
            Order Reports
          </span>
        </div>
      </li>
      <li>
        <div
          onClick={() => handleNavigation(APP_ROUTES.REFERTO)}
          className={`flex items-center gap-3 md:px-2 py-2  cursor-pointer  ${
            isMenuItemActive(APP_ROUTES.REFERTO)
              ? "bg-brand-primaryColor rounded-lg"
              : " "
          } `}
        >
          <div>
            <Tooltip placement="right" title={"Referal"}>
              <img
                src={referal}
                alt=""
                className={` h-6 w-6 ${
                  isMenuItemActive(APP_ROUTES.REFERTO)
                    ? "text-white bg-white p-[3px] rounded-lg"
                    : "text-[#189FAA]  "
                }`}
              />
            </Tooltip>
          </div>
          <span
            className={`${
              isMenuItemActive(APP_ROUTES.REFERTO)
                ? "text-white font-bold"
                : "text-[#041346]"
            } font-semibold md:text-base text-sm ${
              !isMenuOpen ? "hidden" : ""
            }`}
          >
            Referral
          </span>
        </div>
      </li>
      {loginResultObject?.user?.dietChartApplicableYN === "Y" && (
        <>
          {/* <li>
            <div
              onClick={() => handleNavigation(APP_ROUTES.DIETPLAN)}
              className={`flex items-center gap-3 md:px-2 py-2  cursor-pointer  ${
                isMenuItemActive(APP_ROUTES.DIETPLAN)
                  ? "bg-brand-primaryColor  rounded-lg"
                  : " "
              } `}
            >
              <div>
                <Tooltip placement="right" title={"Diet Plan"}>
                  <FaAppleAlt
                    className={` h-6 w-6 ${
                      isMenuItemActive(APP_ROUTES.DIETPLAN)
                        ? "text-white"
                        : " text-[#189FAA] "
                    }`}
                  />
                </Tooltip>
              </div>
              <span
                className={`${
                  isMenuItemActive(APP_ROUTES.DIETPLAN)
                    ? "text-white font-bold"
                    : "text-[#041346]"
                } font-semibold md:text-base text-sm ${
                  !isMenuOpen ? "hidden" : ""
                }`}
              >
                Diet Plan
              </span>
            </div>
          </li> */}
          <li>
            <div
              onClick={() => handleNavigation(APP_ROUTES.DIETCHART)}
              className={`flex items-center gap-3 md:px-2 py-2  cursor-pointer  ${
                isMenuItemActive(APP_ROUTES.DIETCHART)
                  ? "bg-brand-primaryColor  rounded-lg"
                  : " "
              } `}
            >
              <div>
                <Tooltip placement="right" title={"Diet Chart"}>
                  <FaAppleAlt
                    className={` h-6 w-6 ${
                      isMenuItemActive(APP_ROUTES.DIETCHART)
                        ? "text-white"
                        : " text-black "
                    }`}
                  />
                </Tooltip>
              </div>
              <span
                className={`${
                  isMenuItemActive(APP_ROUTES.DIETCHART)
                    ? "text-white font-bold"
                    : "text-[#041346]"
                } font-semibold md:text-base text-sm ${
                  !isMenuOpen ? "hidden" : ""
                }`}
              >
                Diet Chart Config
              </span>
            </div>
          </li>
        </>
      )}
      <li>
        <div
          onClick={() => handleNavigation(APP_ROUTES.MAPPEDCLINICS)}
          className={`flex items-center gap-3 md:px-2 py-2  cursor-pointer  ${
            isMenuItemActive(APP_ROUTES.MAPPEDCLINICS)
              ? "bg-brand-primaryColor  rounded-lg"
              : " "
          } `}
        >
          <div>
            <Tooltip placement="right" title={"Mapped Clinics"}>
              <BiClinic
                className={` h-6 w-6 ${
                  isMenuItemActive(APP_ROUTES.MAPPEDCLINICS)
                    ? "text-black bg-white p-[3px] rounded-lg"
                    : " text-black "
                }`}
              />
            </Tooltip>
          </div>
          <span
            className={`${
              isMenuItemActive(APP_ROUTES.MAPPEDCLINICS)
                ? "text-white font-bold"
                : "text-[#041346]"
            } font-semibold md:text-base text-sm ${
              !isMenuOpen ? "hidden" : ""
            }`}
          >
            Mapped Clinics
          </span>
        </div>
      </li>
      <li>
        <div
          onClick={() => handleNavigation(APP_ROUTES.SETTINGS)}
          className={`flex items-center gap-3 md:px-2 py-2  cursor-pointer  ${
            isMenuItemActive(APP_ROUTES.SETTINGS)
              ? "bg-brand-primaryColor  rounded-lg"
              : " "
          } `}
        >
          <div>
            <Tooltip placement="right" title={"Change Password"}>
              <img
                src={settings}
                alt=""
                className={` h-6 w-6 ${
                  isMenuItemActive(APP_ROUTES.SETTINGS)
                    ? "text-white bg-white p-[3px] rounded-lg"
                    : " text-[#189FAA] "
                }`}
              />
            </Tooltip>
          </div>
          <span
            className={`${
              isMenuItemActive(APP_ROUTES.SETTINGS)
                ? "text-white font-bold"
                : "text-[#041346]"
            } font-semibold md:text-base text-sm ${
              !isMenuOpen ? "hidden" : ""
            }`}
          >
            Change Password
          </span>
        </div>
      </li>
      <li>
        <div
          onClick={() => handleLogout(APP_ROUTES.LOGINFORM)}
          className={`flex items-center gap-3 md:px-2 py-2  cursor-pointer  ${
            isMenuItemActive(APP_ROUTES.LOGINFORM)
              ? "bg-[#d4ebfc]  rounded-lg"
              : " "
          } `}
        >
          <div>
            <Tooltip placement="right" title={"Logout"}>
              <img
                src={logout}
                alt=""
                className={` h-6 w-6 ${
                  isMenuItemActive(APP_ROUTES.LOGINFORM)
                    ? "text-white bg-white p-[3px] rounded-lg"
                    : "text-[#189FAA]  "
                }`}
              />
            </Tooltip>
          </div>
          <span
            className={`${
              isMenuItemActive(APP_ROUTES.LOGOUT)
                ? "text-[#189FAA] font-bold"
                : "text-[#041346]"
            } font-semibold md:text-base text-sm ${
              !isMenuOpen ? "hidden" : ""
            }`}
          >
            Logout
          </span>
        </div>
      </li>
    </ul>
  );
}

export default Sidemenu;
